import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/moving-boxes-shipping-services.jpg'),
    alt: 'moving boxes shipping services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'moving boxes shipping services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Moving <span>Boxes</span><span>Shipping Services Fast</span>',
  description:
    'ShipAndStorage provides moving boxes shipping services designed for individuals, families, and businesses looking for a stress-free shipping experience.',
  image: {
    url: '/images/v2/pages/landing-pages/moving-boxes-shipping-services/hero-image.jpg',
    alt: 'Moving Boxes Shipping Services Fast'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Moving Boxes Shipping' }
}

export const ourProcessSectionContent = {
  title: 'Reliable Moving Boxes Shipping Solutions',
  description: 'We make moving boxes shipping services simple, reliable, and convenient.',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/moving-boxes-shipping-services/reliable-moving-boxes-shipping-solutions.png',
    alt: 'Reliable Moving Boxes Shipping Solutions'
  },

  articles: [
    {
      id: 1,
      title: 'Step 1: Easy Online Booking',
      description:
        'Schedule your shipment online in just a few minutes. Select your pickup and delivery locations, enter box dimensions, and get instant pricing.',
      image: {
        src: '/images/v2/pages/common/easy-online-booking.png',
        alt: 'Step 1: Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Step 2: Secure Packaging & Labeling',
      description:
        'Receive prepaid shipping labels and professional packing tips to ensure your boxes are safely prepared for transport.',
      image: {
        src: '/images/v2/pages/common/secure-packaging-labeling.png',
        alt: 'Step 2: Secure Packaging & Labeling'
      }
    },
    {
      id: 3,
      title: 'Step 3: Door-to-Door Delivery',
      description:
        'Our trusted carriers pick up your boxes and deliver them directly to your destination, with tracking updates throughout the journey.',
      image: {
        src: '/images/v2/pages/common/shipping-services.png',
        alt: 'Step 3: Door-to-Door Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure Moving Boxes Shipping Services',
  description:
    "With ShipAndStorage, your boxes are in safe hands. Our moving boxes shipping services include professional handling, real-time tracking, and insurance coverage for added security. Whether you're shipping a single box or multiple packages, we ensure damage-free transportation with reliable shipping partners like FedEx and DHL.",
  image: {
    src: '/images/v2/pages/landing-pages/moving-boxes-shipping-services/secure-moving-boxes-shipping-services.jpg',
    alt: 'Secure Moving Boxes Shipping Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Moving Boxes Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description: 'Avoid the hassle of carrying heavy boxes—schedule a pickup from your home, office, or dorm.',
      image: {
        src: '/images/v2/pages/common/easy-access-and-convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Cost-Effective',
      description:
        'Our competitive pricing ensures affordable shipping with no hidden fees for both domestic and international deliveries.',
      image: {
        src: '/images/v2/pages/common/cost-savings.png',
        alt: 'Cost-Effective'
      }
    },
    {
      id: 3,
      title: 'Real-Time Tracking',
      description: 'Stay informed with live shipment updates from pickup to final delivery.',
      image: {
        src: '/images/v2/pages/common/real-time-tracking.png',
        alt: 'Real-Time Tracking'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Moving Boxes Shipping Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students moving in or out of dorms',
          description: 'Simplify your college move with hassle-free box shipping.'
        },
        {
          id: 2,
          title: 'Families relocating to a new home',
          description: 'Ship your household items safely and affordably.'
        },
        {
          id: 3,
          title: 'Businesses needing secure document or inventory shipping',
          description: 'Send office supplies, files, or stock with confidence.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/moving-boxes-shipping-services/who-should-choose-us-for-moving-boxes-shipping-services.jpg',
        alt: 'Who Should Choose Us for Moving Boxes Shipping Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Luggage Shipping',
      description:
        'Ship your luggage without worrying about airline fees or baggage limits. Our service ensures a smooth travel experience.',
      image: {
        src: '/images/v2/pages/common/luggage-shipping-services.png',
        alt: 'Luggage Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Golf Club Shipping',
      description:
        'Avoid the hassle of carrying heavy golf clubs—let us handle their safe and timely delivery to your destination.',
      image: {
        src: '/images/v2/pages/common/Golf-Club-Shipping.png',
        alt: 'Golf Club Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Local and International Shipping',
      description:
        'Whether shipping within your city or to another country, we offer reliable domestic and global shipping options.',
      image: {
        src: '/images/v2/pages/common/international-storage-options.png',
        alt: 'Local and International Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Ski and Snowboard Shipping',
      description: 'Ensure your winter gear arrives at your ski destination securely and damage-free.',
      image: {
        src: '/images/v2/pages/common/sports-equipment-storage.png',
        alt: 'Ski and Snowboard Shipping'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Moving Boxes Shipping Services?',

  image: {
    url: '/images/v2/pages/landing-pages/moving-boxes-shipping-services/why-choose-shipandstorage-for-moving-boxes-shipping-services.jpg',
    alt: 'Why Choose ShipAndStorage for Moving Boxes Shipping Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Fast & Reliable Shipping',
      description:
        'We provide efficient moving boxes shipping services with quick turnaround times, ensuring your boxes arrive at their destination on schedule.'
    },
    {
      id: 2,
      title: 'Door-to-Door Convenience',
      description:
        'Enjoy hassle-free shipping with our pickup and delivery service, eliminating the need to transport boxes to a shipping center.'
    },
    {
      id: 3,
      title: 'Cost-Effective Solutions',
      description:
        'Our competitive pricing and transparent rates make moving boxes shipping services affordable for individuals, students, and businesses.'
    },
    {
      id: 4,
      title: 'Real-Time Tracking',
      description:
        'Track your shipment every step of the way with our advanced tracking system, providing real-time updates on your moving boxes.'
    },
    {
      id: 5,
      title: 'Secure Packaging & Handling',
      description:
        'Your boxes are handled with care, with sturdy packaging and optional insurance to protect your items during transit.'
    },
    {
      id: 6,
      title: 'Global Shipping Coverage',
      description:
        'Ship your moving boxes domestically or internationally to over 220 destinations with trusted carrier partnerships.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Fast Moving Boxes Shipping Services Available',
  description:
    'Moving boxes shipping services available now. Fast, secure, and affordable options for shipping your moving boxes safely and easily.',
  image: {
    src: '/images/v2/pages/landing-pages/moving-boxes-shipping-services/fast-moving-boxes-shipping-services-available.png',
    alt: 'Fast Moving Boxes Shipping Services Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Request a Shipping Quote' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'At ShipAndStorage, we collaborate with top logistics providers to deliver exceptional storage and shipping solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'As a renowned global logistics leader, FedEx ensures your belongings are securely stored and transported.',
        "<strong>Disclaimer: </strong>This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers reliable global logistics services, providing secure storage and transport for your items, especially during the busy summer months.',
        "<strong>Disclaimer: </strong>This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS specializes in secure storage and comprehensive global shipping solutions, ensuring your items are handled with the utmost care throughout the entire process.',
        "<strong>Disclaimer: </strong>This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more details, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
